import React, { Component } from 'react'
import { Button, Empty, Modal, Skeleton } from 'hljd'
import style from '../style.module.less'
import { observer } from 'mobx-react'
import Store from './store'
import { HOME_PATH_A, REALNAME_AUTH_PATH_A } from '@constant'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    const {
      params: { posterId }
    } = this.props
    this.store.getContractInfo(posterId)
  }
  render() {
    const {
      contractInfo,
      agreeBtnLoading,
      agreeContract,
      disagree,
      requestDirty
    } = this.store
    return (
      <>
        <div className={style.contract}>
          <Skeleton
            loading={contractInfo.loading}
            paragraph={{ rows: 4 }}
            active={true}
          >
            {contractInfo.agreement.title ? (
              <>
                <h1 style={{ textAlign: 'center', fontWeight: 'bold' }}>
                  {contractInfo.agreement.title}
                </h1>
                <div style={{ minHeight: 90 }}>
                  <p>甲方：{contractInfo.merchant.name}</p>
                  <p>住所：{contractInfo.merchant.address}</p>
                  <p>
                    统一社会信用代码/身份证号：{
                      contractInfo.merchant.companyCode
                    }
                  </p>
                </div>
                <br />
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<div>${contractInfo.agreement.content}</div>`
                  }}
                />
              </>
            ) : (
              <Empty description="获取协议失败" />
            )}
          </Skeleton>
        </div>
        <div style={{ marginTop: 20 }}>
          {contractInfo.isSign ? (
            <Button
              type="primary"
              onClick={() => {
                window.location.href = HOME_PATH_A
              }}
            >
              已同意该协议
            </Button>
          ) : (
            <>
              <Button style={{ marginRight: 20 }} onClick={disagree}>
                不同意
              </Button>
              <Button
                loading={agreeBtnLoading}
                type="primary"
                onClick={agreeContract}
              >
                {agreeBtnLoading ? '提交中' : '同意'}
              </Button>
            </>
          )}
        </div>
        <Modal
          title="重要通知"
          closable={false}
          visible={
            requestDirty &&
            (!contractInfo.merchant.name || !contractInfo.merchant.companyCode)
          }
          footer={
            <Button
              type="primary"
              onClick={() => {
                window.location.href = REALNAME_AUTH_PATH_A
              }}
            >
              立即完善
            </Button>
          }
        >
          为更好的保障广大商家的权益，现要求全平台上传企业名称及统一社会信用代码。请尽快完成上传，以免影响店铺正常经营。（逾期未传将无法使用其他功能）
        </Modal>
      </>
    )
  }
}
